import React, { ReactNode } from 'react';

import './Modal.scss';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';

type ModalProps = {
    children?: ReactNode;
    closeHandler: Function;
    open: boolean;
    title?: string;
    size: 'lg' | 'md' | 'sm' | 'xl' | 'xs';
    customClass?: string;
    noTitle?: boolean;
    disableFullScreen?: boolean;
};

const Modal: React.FC<ModalProps> = (props) => {
    const {
        children,
        closeHandler,
        customClass,
        open,
        title,
        size,
        noTitle,
        disableFullScreen,
    } = props;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down(size));

    const handleClose = () => {
        closeHandler();
    };

    return (
        <Dialog
            fullScreen={disableFullScreen ? false : fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
            maxWidth={size}
            fullWidth={true}
            className={customClass}
        >
            {noTitle ? null : (
                <DialogTitle className={'modal-title'} id="responsive-dialog-title">
                    {title}
                </DialogTitle>
            )}
            <IconButton
                aria-label="close"
                className={
                    customClass ? 'dark-colose-btn modal-close-btn' : 'modal-close-btn'
                }
                onClick={handleClose}
            >
                <Close />
            </IconButton>
            <DialogContent style={{ padding: "0" }} className="modal-content-ctn">{children}</DialogContent>
        </Dialog>
    );
};

export default Modal;
